import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text, Box} from '@salesforce/retail-react-app/app/components/shared/ui'

const NoReturnNotification = () => {
    return (
        <Box mb="8">
            <Text fontSize="xs">
                <FormattedMessage
                    defaultMessage="* No returns or exchanges"
                    id="cart_notification.no_return_notification"
                />
            </Text>
        </Box>
    )
}

export default NoReturnNotification
